/* SkillzCutz & Locs Studio — booking wizard
   Availability is read live from the appointment products; every time slot is a
   variant with inventory 1, so Shopify guarantees no double bookings. */
(function () {
  'use strict';

  var root = document.querySelector('[data-booking]');
  if (!root) return;

  var cfg = JSON.parse(document.getElementById('BookingConfig').textContent);
  var form = document.getElementById('BookingForm');
  var steps = Array.prototype.slice.call(root.querySelectorAll('.booking-step'));
  var progressSteps = Array.prototype.slice.call(root.querySelectorAll('.booking-progress__step'));
  var backBtn = root.querySelector('[data-step-back]');
  var nextBtn = root.querySelector('[data-step-next]');
  var submitBtn = root.querySelector('[data-booking-submit]');
  var errorEl = root.querySelector('[data-step-error]');
  var variantInput = root.querySelector('[data-slot-variant]');
  var current = 0;

  var state = {
    city: '',
    dubaiTier: 'home',
    slots: {},      /* date -> [{time, id, available}] */
    dates: [],
    pickedDate: '',
    pickedTime: '',
    depositLabel: '$10',
    travelEstimate: '',
    loaded: ''
  };

  /* ---------- helpers ---------- */
  function showError(msg) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
  function hideError() { errorEl.classList.remove('is-visible'); }
  function getRadio(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }
  function val(name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }
  function cityTz() { return state.city === 'Dubai' ? 'Asia/Dubai' : 'Africa/Lagos'; }

  /* "now" in the city timezone, as {date: 'YYYY-MM-DD', minutes: N} */
  function nowInCity() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: cityTz(), year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    return {
      date: map.year + '-' + map.month + '-' + map.day,
      minutes: parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10)
    };
  }
  function toMinutes(hhmm) {
    var p = hhmm.split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1], 10);
  }
  function timeLabel(hhmm) {
    var m = toMinutes(hhmm);
    var h = Math.floor(m / 60);
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + hhmm.split(':')[1] + ' ' + (h < 12 ? 'AM' : 'PM');
  }
  function dateBits(iso) {
    var d = new Date(iso + 'T00:00:00');
    return { day: cfg.dayNames[d.getDay()], num: d.getDate(), month: cfg.monthNames[d.getMonth()], dow: d.getDay() };
  }

  /* ---------- step navigation ---------- */
  function showStep(i) {
    current = i;
    steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    progressSteps.forEach(function (p, idx) {
      p.classList.toggle('is-active', idx === i);
      p.classList.toggle('is-done', idx < i);
    });
    backBtn.style.visibility = i === 0 ? 'hidden' : 'visible';
    nextBtn.style.display = i === steps.length - 1 ? 'none' : '';
    submitBtn.style.display = i === steps.length - 1 ? '' : 'none';
    hideError();
    if (steps[i].getAttribute('data-step') === 'time') loadAvailability();
    if (i === steps.length - 1) buildSummary();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(i) {
    var key = steps[i].getAttribute('data-step');
    if (key === 'city' && !getRadio('booking_city')) return 'Please pick your city.';
    if (key === 'place' && state.city === 'Dubai' && state.dubaiTier === 'home') {
      var area = form.querySelector('[data-dubai-area]');
      if (!state.travelEstimate && (!area || !area.value)) return 'Please choose your area (or use your exact location).';
    }
    if (key === 'style' && !getRadio('booking_style')) return 'Please pick a style — or choose “Not sure yet”.';
    if (key === 'time') {
      if (!state.pickedDate || !state.pickedTime || !variantInput.value) return 'Please pick an available date and time.';
    }
    if (key === 'details') {
      if (!val('properties[Name]')) return 'Please enter your name.';
      if (!val('properties[Phone]')) return 'Please enter your phone number so we can confirm your booking.';
      if (isHomeVisit() && !val('properties[Address]')) return 'Please enter the address we should come to.';
    }
    return '';
  }

  nextBtn.addEventListener('click', function () {
    var err = validateStep(current);
    if (err) { showError(err); return; }
    showStep(Math.min(current + 1, steps.length - 1));
  });
  backBtn.addEventListener('click', function () { showStep(Math.max(current - 1, 0)); });

  /* ---------- city + place toggles ---------- */
  var lagosPlace = form.querySelector('[data-lagos-place]');
  var dubaiPlace = form.querySelector('[data-dubai-place]');
  var dubaiHomeWrap = form.querySelector('[data-dubai-home]');
  var walkinNote = form.querySelector('[data-walkin-note]');
  var addressWrap = form.querySelector('[data-home-address]');
  var homeNote = form.querySelector('[data-home-note]');

  /* Is the current selection a home visit (Lagos home OR Dubai home service)? */
  function isHomeVisit() {
    if (state.city === 'Dubai') return state.dubaiTier === 'home';
    return getRadio('booking_location') === 'Home service';
  }

  function syncPlace() {
    var isDubai = state.city === 'Dubai';
    if (lagosPlace) lagosPlace.style.display = isDubai ? 'none' : '';
    if (dubaiPlace) dubaiPlace.style.display = isDubai ? '' : 'none';
    /* Dubai: distance picker only for home service; walk-in shows the JVC note */
    if (dubaiHomeWrap) dubaiHomeWrap.style.display = (isDubai && state.dubaiTier === 'home') ? '' : 'none';
    if (walkinNote) walkinNote.style.display = (isDubai && state.dubaiTier === 'walkin') ? '' : 'none';
    var isHome = isHomeVisit();
    if (addressWrap) addressWrap.style.display = isHome ? '' : 'none';
    if (homeNote) homeNote.style.display = (!isDubai && getRadio('booking_location') === 'Home service') ? '' : 'none';
  }

  /* Price labels follow the region AND, for Dubai, the walk-in/home tier. */
  function applyBookingPrices() {
    var reg = state.city === 'Dubai' ? 'aed' : 'ngn';
    var tier = state.dubaiTier || 'home';
    form.querySelectorAll('.style-pick small[data-price-ngn]').forEach(function (el) {
      var label;
      if (reg === 'ngn') {
        label = el.getAttribute('data-price-ngn');
      } else {
        var cat = el.getAttribute('data-aed-cat');
        if (cat && cfg.dubaiPrices && cfg.dubaiPrices[cat]) label = cfg.dubaiPrices[cat][tier];
        if (!label) label = el.getAttribute('data-price-aed');
      }
      if (label) el.textContent = label;
    });
  }

  form.querySelectorAll('input[name="booking_city"]').forEach(function (input) {
    input.addEventListener('change', function () {
      state.city = input.value;
      state.pickedDate = '';
      state.pickedTime = '';
      variantInput.value = '';
      syncPlace();
      applyBookingPrices();
    });
  });
  form.querySelectorAll('input[name="booking_location"]').forEach(function (input) {
    input.addEventListener('change', syncPlace);
  });
  form.querySelectorAll('input[name="booking_dubai_tier"]').forEach(function (input) {
    input.addEventListener('change', function () {
      state.dubaiTier = input.value;
      if (state.dubaiTier === 'walkin') state.travelEstimate = ''; /* no travel fee for walk-in */
      syncPlace();
      applyBookingPrices();
    });
  });

  /* ---------- Dubai distance / travel fee ---------- */
  var areaSelect = form.querySelector('[data-dubai-area]');
  var geoBtn = form.querySelector('[data-geo-btn]');
  var distanceBox = form.querySelector('[data-distance-result]');
  var distanceText = form.querySelector('[data-distance-text]');

  function setTravel(km, label) {
    var fee = Math.round(cfg.feeBase + cfg.feePerKm * km);
    state.travelEstimate = '~$' + fee + ' travel fee (' + label + ', ~' + Math.round(km) + ' km from our JVC base)';
    if (distanceBox) distanceBox.style.display = '';
    if (distanceText) {
      distanceText.textContent = 'About ' + Math.round(km) + ' km from our base — estimated travel fee $' + fee + '. Exact fee confirmed when we contact you.';
    }
  }
  if (areaSelect) {
    areaSelect.addEventListener('change', function () {
      var opt = areaSelect.options[areaSelect.selectedIndex];
      var km = parseFloat(opt.getAttribute('data-km'));
      if (!isNaN(km)) setTravel(km, opt.value);
    });
  }
  if (geoBtn) {
    geoBtn.addEventListener('click', function () {
      if (!navigator.geolocation) { showError('Location not supported on this device — please pick your area instead.'); return; }
      geoBtn.disabled = true;
      geoBtn.textContent = 'Locating…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        var R = 6371;
        var dLat = (pos.coords.latitude - cfg.dubaiBase[0]) * Math.PI / 180;
        var dLon = (pos.coords.longitude - cfg.dubaiBase[1]) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(cfg.dubaiBase[0] * Math.PI / 180) * Math.cos(pos.coords.latitude * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var km = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        setTravel(km, 'your location');
        geoBtn.disabled = false;
        geoBtn.textContent = 'Location found ✓';
        hideError();
      }, function () {
        geoBtn.disabled = false;
        geoBtn.textContent = 'Or use my exact location';
        showError('Couldn’t read your location — please pick your area from the list.');
      }, { timeout: 8000 });
    });
  }

  /* ---------- live availability ---------- */
  var dateStrip = form.querySelector('[data-date-strip]');
  var slotGrid = form.querySelector('[data-slot-grid]');
  var tzHint = form.querySelector('[data-tz-hint]');

  /* Availability is rendered into the page by Liquid (BookingConfig.lagosSlots /
     dubaiSlots) — no network request needed, so rate limits, ad blockers and
     flaky connections can't break the calendar. */
  function cityPhoneLinks() {
    var bits = [];
    var phone = state.city === 'Dubai' && cfg.phoneDubai ? cfg.phoneDubai : cfg.phoneLagos;
    var wa = state.city === 'Dubai' && cfg.whatsappDubai ? cfg.whatsappDubai : cfg.whatsapp;
    if (phone) bits.push('<a href="tel:' + phone.replace(/ /g, '') + '" style="color:var(--c-gold-soft);text-decoration:underline">call ' + phone + '</a>');
    if (wa) bits.push('<a href="https://wa.me/' + wa + '" target="_blank" rel="noopener" style="color:var(--c-gold-soft);text-decoration:underline">WhatsApp us</a>');
    return bits.join(' or ');
  }

  function loadAvailability() {
    if (tzHint) tzHint.textContent = state.city === 'Dubai' ? '(Dubai time)' : '(Lagos time)';
    if (state.loaded === state.city) { renderDates(); return; }
    var raw = state.city === 'Dubai' ? cfg.dubaiSlots : cfg.lagosSlots;
    state.slots = {};
    state.dates = [];
    state.depositLabel = '$' + (cfg.deposit / 100).toFixed(0);
    var dep = root.querySelector('[data-deposit-amount]');
    if (dep) dep.textContent = state.depositLabel;
    (raw || []).forEach(function (row) {
      var parts = String(row[0]).split(' ');
      if (parts.length !== 2) return;
      var date = parts[0], time = parts[1];
      if (!state.slots[date]) { state.slots[date] = []; state.dates.push(date); }
      state.slots[date].push({ time: time, id: row[2], available: row[1] === 1 });
    });
    state.dates.sort();
    state.loaded = state.city;
    if (!state.dates.length) {
      dateStrip.innerHTML = '<p class="slot-empty">Online booking for ' + (state.city || 'this city') + ' is being refreshed — ' + cityPhoneLinks() + ' and we’ll book you in personally.</p>';
      slotGrid.innerHTML = '';
      return;
    }
    renderDates();
  }

  function slotIsBookable(date, slot, now) {
    if (!slot.available) return false;
    if (date < now.date) return false;
    if (date === now.date && toMinutes(slot.time) < now.minutes + cfg.leadHours * 60) return false;
    return true;
  }

  function renderDates() {
    var now = nowInCity();
    dateStrip.innerHTML = '';
    var firstEnabled = '';
    state.dates.forEach(function (date) {
      if (date < now.date) return; /* past dates: don't render at all */
      var bits = dateBits(date);
      var closed = cfg.closedDays.indexOf(bits.dow) !== -1;
      var hasSlot = !closed && state.slots[date].some(function (s) { return slotIsBookable(date, s, now); });
      var lab = document.createElement('label');
      lab.className = 'date-chip' + (hasSlot ? '' : ' is-off');
      lab.innerHTML = '<input type="radio" name="booking_date_pick" value="' + date + '"' + (hasSlot ? '' : ' disabled') + '>' +
        '<span><small>' + bits.day + '</small><strong>' + bits.num + '</strong><small>' + bits.month + '</small></span>';
      dateStrip.appendChild(lab);
      if (hasSlot && !firstEnabled) firstEnabled = date;
    });
    dateStrip.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', function () {
        state.pickedDate = input.value;
        state.pickedTime = '';
        variantInput.value = '';
        renderTimes();
      });
    });
    if (state.pickedDate && state.dates.indexOf(state.pickedDate) !== -1) {
      var keep = dateStrip.querySelector('input[value="' + state.pickedDate + '"]');
      if (keep && !keep.disabled) { keep.checked = true; renderTimes(); return; }
    }
    /* Beyond-the-window note: dates further out are booked by phone */
    var lastDate = state.dates[state.dates.length - 1];
    if (lastDate) {
      var note = document.createElement('p');
      note.className = 'slot-empty';
      note.style.marginTop = '0.6rem';
      note.innerHTML = 'Need a date after ' + lastDate + '? ' + cityPhoneLinks().replace(/^c/, 'C') + ' and we’ll reserve it for you.';
      dateStrip.parentElement.appendChild(note);
      if (dateStrip.parentElement.querySelectorAll('p.slot-empty').length > 1) {
        var notes = dateStrip.parentElement.querySelectorAll('p.slot-empty');
        for (var n = 0; n < notes.length - 1; n++) notes[n].remove();
      }
    }
    if (firstEnabled) {
      var first = dateStrip.querySelector('input[value="' + firstEnabled + '"]');
      first.checked = true;
      state.pickedDate = firstEnabled;
      renderTimes();
    } else {
      slotGrid.innerHTML = '<p class="slot-empty">Fully booked online for the next two weeks — ' + cityPhoneLinks() + ' and we’ll fit you in.</p>';
    }
  }

  function renderTimes() {
    var now = nowInCity();
    slotGrid.innerHTML = '';
    var any = false;
    (state.slots[state.pickedDate] || []).forEach(function (slot) {
      var ok = slotIsBookable(state.pickedDate, slot, now);
      var lab = document.createElement('label');
      lab.className = 'slot' + (ok ? '' : ' is-off');
      lab.innerHTML = '<input type="radio" name="booking_time_pick" value="' + slot.time + '" data-variant="' + slot.id + '"' + (ok ? '' : ' disabled') + '>' +
        '<span>' + timeLabel(slot.time) + (slot.available ? '' : '<em>booked</em>') + '</span>';
      slotGrid.appendChild(lab);
      if (ok) any = true;
    });
    if (!any) slotGrid.innerHTML = '<p class="slot-empty">No slots left this day — try another date.</p>';
    slotGrid.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', function () {
        state.pickedTime = input.value;
        variantInput.value = input.getAttribute('data-variant');
      });
    });
  }

  /* ---------- deep links: ?city= & ?style= ---------- */
  try {
    var params = new URLSearchParams(window.location.search);
    var qCity = params.get('city');
    if (qCity) {
      var cityInput = form.querySelector('input[name="booking_city"][value="' + CSS.escape(qCity) + '"]');
      if (cityInput) { cityInput.checked = true; state.city = qCity; syncPlace(); }
    }
    var qStyle = params.get('style');
    if (qStyle) {
      var styleInput = form.querySelector('input[name="booking_style"][value="' + CSS.escape(qStyle) + '"]');
      if (styleInput) styleInput.checked = true;
    }
  } catch (e) { /* ignore */ }

  /* Default the city to the visitor's region (UAE devices → Dubai) unless a
     deep link already chose one. Prices in the style step follow the city. */
  if (!state.city && document.documentElement.getAttribute('data-region') === 'aed') {
    var regionCity = form.querySelector('input[name="booking_city"][value="Dubai"]');
    if (regionCity) {
      regionCity.checked = true;
      state.city = 'Dubai';
      syncPlace();
    }
  }
  applyBookingPrices();

  /* ---------- review ---------- */
  function summaryData() {
    var isHome = isHomeVisit();
    var service;
    if (state.city === 'Dubai') {
      service = state.dubaiTier === 'walkin' ? 'Walk-in — JVC studio' : 'Home service (Dubai)';
    } else {
      service = getRadio('booking_location');
    }
    return [
      ['City', state.city],
      ['Service', service],
      ['Style', getRadio('booking_style')],
      ['Date', state.pickedDate],
      ['Time', state.pickedTime ? timeLabel(state.pickedTime) : ''],
      ['Name', val('properties[Name]')],
      ['Phone', val('properties[Phone]')],
      ['Address', isHome ? val('properties[Address]') : ''],
      ['Travel estimate', (state.city === 'Dubai' && state.dubaiTier === 'home') ? state.travelEstimate : ''],
      ['Confirm via', getRadio('properties[Confirm via]')],
      ['Deposit', state.depositLabel + ' (comes off your final price)']
    ].filter(function (r) { return r[1]; });
  }

  function buildSummary() {
    var dl = root.querySelector('[data-booking-summary]');
    dl.innerHTML = '';
    summaryData().forEach(function (row) {
      var div = document.createElement('div');
      div.className = 'booking-summary__row';
      var dt = document.createElement('dt');
      dt.textContent = row[0];
      var dd = document.createElement('dd');
      dd.textContent = row[1];
      div.appendChild(dt);
      div.appendChild(dd);
      dl.appendChild(div);
    });
    var svc;
    if (state.city === 'Dubai') {
      svc = state.dubaiTier === 'walkin' ? 'Walk-in — JVC studio' : 'Home service (Dubai)';
    } else {
      svc = getRadio('booking_location');
    }
    root.querySelector('[data-prop-city]').value = state.city;
    root.querySelector('[data-prop-service]').value = svc;
    root.querySelector('[data-prop-style]').value = getRadio('booking_style');
    root.querySelector('[data-prop-travel]').value = (state.city === 'Dubai' && state.dubaiTier === 'home') ? state.travelEstimate : '';
    var wa = root.querySelector('[data-whatsapp-link]');
    var waNumber = state.city === 'Dubai' && cfg.whatsappDubai ? cfg.whatsappDubai : cfg.whatsapp;
    if (wa && waNumber) {
      var text = 'Booking change request — ' + cfg.shopName + '\n' +
        summaryData().map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
      wa.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(text);
    }
  }

  /* ---------- submit ---------- */
  form.addEventListener('submit', function (e) {
    for (var i = 0; i < steps.length; i++) {
      var err = validateStep(i);
      if (err) { e.preventDefault(); showStep(i); showError(err); return; }
    }
    if (!variantInput.value) { e.preventDefault(); showError('Please pick a time slot.'); return; }
    submitBtn.disabled = true;
    submitBtn.textContent = 'Taking you to secure checkout…';
  });

  showStep(0);
})();
